module.exports = __webpack_public_path__ + "img/flirProduct.28821702.png";